// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_1dh","cls2":"FriendlySutdModal-cls2_kAW FriendlySutdModal-cls1_1dh"};